module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/自动贴片站.ca3de1a3.jpg";